import { Component, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSlider, MatSliderThumb } from '@angular/material/slider';
import { MatTooltip } from '@angular/material/tooltip';
import { isRequired } from '../../utilities/form-control.util';

@Component({
  selector: 'procure-input-slider',
  templateUrl: './input-slider.component.html',
  styleUrl: './input-slider.component.scss',
  imports: [
    MatSlider,
    MatSliderThumb,
    ReactiveFormsModule,
    MatIcon,
    MatTooltip,
    MatLabel,
  ],
})
export class InputSlider {
  readonly label = input.required<string>();
  readonly control = input.required<FormControl>();
  readonly showMode = input.required<boolean>();
  readonly hint = input<string>();
  readonly min = input(0);
  readonly max = input(100);
  readonly step = input(1);

  readonly displayWith = input<(value: number) => string>(
    (value) => `${value}`,
  );

  readonly changed = output<number>();

  protected get isRequired(): boolean {
    return isRequired(this.control());
  }
}
